import React, {Component} from 'react';
import {
    Route,
    Switch,
    Redirect
} from 'react-router-dom';
import NotificationSystem from 'react-notification-system';

import Header from 'components/Header/Header';
import Footer from 'components/Footer/Footer';
import Sidebar from 'components/Sidebar/Sidebar';

import {style} from "variables/Variables.jsx";

import appRoutes from 'routes/app.jsx';

import fire from 'fire.js';
import firebase from 'firebase'
import moment from 'moment';
import 'moment-timezone';
import 'twix';


class App extends Component {
    constructor(props) {
        super(props);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.handleNotificationClick = this.handleNotificationClick.bind(this);
        this.setUser = this.setUser.bind(this);
        this.componentWillMount = this.componentWillMount.bind(this);
        this.login = this.login.bind(this);
        this.logout = this.logout.bind(this);
        this.clearUser = this.clearUser.bind(this);
    }

    state = App.initialState;

    static initialState = {
        _notificationSystem: null,
        submissions: {},
        school: {},
        schoolKey: null,
        // schoolKey: 'cpalions',
        revenue: undefined,
        numPaidSubmissions: undefined,
        histogram: {
            dataPie: {
                labels: [],
                series: [],
            },
            legendPie: {
                names: [],
                types: [],
            },
        },
        dateChart: {
            labels: [],
            series: [[]],
        },
        user: null,
    };

    login() {
        let provider = new firebase.auth.GoogleAuthProvider();

        fire.auth()
            .signInWithPopup(provider)
            .then(result => {
                let token = result.credential.accessToken;
                // The signed-in user info.
                let user = result.user;

                this.setUser(token, user.email, user.displayName, user.uid);
            });
    }

    clearUser() {
        this.setState(
            App.initialState
        );
    }

    logout() {
        fire.auth().signOut()
            .then(this.clearUser)
            .catch(function (error) {
                // An error happened.
            });
    }

    setUser(token, email, displayName, uid) {
        // Look up the school key!
        let db = fire.firestore();
        db.collection('accounts')
            .doc(uid)
            .get()
            .then(doc => {
                this.setState({
                    schoolKey: doc.data().schoolname,
                    user: {
                        token: token,
                        email: email,
                        uid: uid,
                        name: displayName,
                    }
                });

                this.loadSchoolData();
            });
    };

    handleNotificationClick(position) {
        let color = Math.floor((Math.random() * 4) + 1),
            level;
        switch (color) {
            case 1:
                level = 'success';
                break;
            case 2:
                level = 'warning';
                break;
            case 3:
                level = 'error';
                break;
            case 4:
                level = 'info';
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: (<span data-notify="icon" className="pe-7s-gift"/>),
            message: (
                <div>
                    Welcome to <b>Light Bootstrap Dashboard</b> - a beautiful freebie for every web developer.
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 15,
        });
    }

    componentWillMount() {
        // this.loadSchoolData();
    }

    loadSchoolData() {
        let db = fire.firestore();
        let all_subs = {};

        if (this.state.schoolKey === null) {
            return;
        }

        db.collection('schools')
            .doc(this.state.schoolKey)
            .get()
            .then(school_data => {
                    // console.log(school_data.data());
                    this.setState({
                        school: school_data.data()
                    }, () => {
                        let year = this.state.school.current_year;
                        let submissionCollection = db.collection('submissions')
                            .doc(this.state.schoolKey)
                            .collection(year);

                        submissionCollection
                            .where('finalized', '==', true)
                            .get()
                            .then(paidSubmissionsResult => {
                                    let paidSubmissions = {};
                                    paidSubmissionsResult.forEach(res => {
                                        paidSubmissions[res.id] = res.data();
                                    });

                                    let {numPaidSubmissions, revenue} = this.calculateStats(paidSubmissions);
                                    let histogram = this.calculateHistogram(paidSubmissions);
                                    let dateChart = this.calculateDateChart(paidSubmissions);
                                    let lateFees = this.calculateLateFees(paidSubmissions);

                                    this.setState({
                                        revenue: revenue,
                                        numPaidSubmissions: numPaidSubmissions,
                                        histogram: histogram,
                                        dateChart: dateChart,
                                        lateFees: lateFees,
                                    }, () => {
                                        submissionCollection
                                            .where('finalized', '==', false)
                                            .where('highCard', '>=', 2)
                                            .get()
                                            .then(nonPaidSubmissionsResult => {
                                                let nonPaidSubmissions = {};
                                                nonPaidSubmissionsResult.forEach(res => {
                                                    nonPaidSubmissions[res.id] = res.data();
                                                });

                                                this.setState({
                                                    submissions: Object.assign({}, paidSubmissions, nonPaidSubmissions),
                                                });
                                            });
                                    });
                                }
                            );
                    });
                }
            );
    }

    calculateLateFees(paidSubmissions) {
        return Object.keys(paidSubmissions)
            .map(key => {
                if ('latefee' in paidSubmissions[key])
                    return paidSubmissions[key].latefee;
                return 0;
            }).reduce((p, e) => {
                return p + e;
            }, 0);
    }

    calculateDateChart(paidSubmissions) {
        // Calculate submissions by date.
        let dates = Object.keys(paidSubmissions)
                .map(key => {
                    return paidSubmissions[key].time * 1000;
                }),
            earliest = dates.reduce((p, e) => {
                if (e < p)
                    return e;
                return p;
            }, 15147637713100),
            latest = dates.reduce((p, e) => {
                if (e > p)
                    return e;
                return p;
            }, 0),
            open = this.state.school.open * 1000,
            deadline = this.state.school.deadline * 1000,
            now = moment.now();

        // console.log(open);
        // console.log(earliest);
        // console.log(latest);
        // console.log(deadline);
        // console.log(now);

        let itr = moment.twix(new Date(open), new Date(deadline))
            .iterate("days");

        let labels = [],
            series = [];

        while (itr.hasNext()) {
            let this_date = itr.next();

            if ('timezone' in this.state.school) {
                labels.push(this_date.tz(this.state.school.timezone).format('MMM D'));
            } else {
                labels.push(this_date.format('MMM D'));
            }

            // How many sales happened on or prior to this date?
            let num = dates.map(key => {
                let d = new Date(key);
                if (d <= this_date)
                    return 1;
                return 0;
            }).reduce((p, e) => {
                return p + e;
            }, 0);

            if (this_date <= now) {
                series.push(num);
            }
        }

        // console.log(labels);
        // console.log(series);

        return {
            'labels': labels,
            'series': [series]
        };
    }

    calculateStats(paidSubmissions) {
        // Calculate stats
        let numPaidSubmissions = Object.keys(paidSubmissions).length,
            revenue = Object.keys(paidSubmissions)
                .map(key => {
                    return paidSubmissions[key].paid;
                })
                .reduce((prevVal, elem) => {
                    return prevVal + elem;
                }, 0);
        return {numPaidSubmissions, revenue};
    }

    calculateHistogram(paidSubmissions) {
        // Calculate pie chart
        let histogram = Object.keys(paidSubmissions)
            .map(key => {
                return paidSubmissions[key].size;
            })
            .reduce((prevVal, elem) => {
                let index = prevVal.legendPie.names.indexOf(elem);

                if (index === -1) {
                    prevVal.legendPie.names.push(elem);
                    prevVal.legendPie.types.push("info");
                    prevVal.dataPie.series.push(1);
                } else
                    prevVal.dataPie.series[index] += 1;

                // Calculate percentages as labels
                let total = prevVal.dataPie.series.reduce((p, e) => {
                    return p + e;
                });
                prevVal.dataPie.labels = prevVal.dataPie.series.map(e => {
                    return e * 100.0 / total;
                });

                return prevVal;
            }, {
                dataPie: {
                    labels: [],
                    series: [],
                },
                legendPie: {
                    names: [],
                    types: [],
                }
            });

        console.log(histogram);
        return histogram;
    }

    componentDidMount() {
        this.setState({_notificationSystem: this.refs.notificationSystem});
    }

    componentDidUpdate(e) {
        if (window.innerWidth < 993 && e.history.location.pathname !== e.location.pathname && document.documentElement.className.indexOf('nav-open') !== -1) {
            document.documentElement.classList.toggle('nav-open');
        }
    }

    render() {
        return (

            <div className="wrapper">
                <NotificationSystem ref="notificationSystem" style={style}/>
                <Sidebar {...this.props}
                         user={this.state.user}/>
                <div id="main-panel" className="main-panel">
                    {this.state.user !== null
                        ? (<Header {...this.props}
                                   logout={this.logout}/>
                        ) : <div/>
                    }

                    <Switch>
                        {
                            appRoutes.map((prop, key) => {
                                if (prop.redirect)
                                    return (
                                        <Redirect from={prop.path} to={prop.to} key={key}/>
                                    );

                                // If this requires login, and we're not signed in, redirect to login.
                                if (prop.signedIn && this.state.user === null)
                                    return (
                                        <Redirect from={prop.path} to='/login' key={key}/>
                                    );

                                if (prop.name === "Login") {
                                    if (this.state.user !== null)
                                        return (
                                            <Redirect from={prop.path} to='/dashboard' key={key}/>
                                        );
                                    else
                                        return (
                                            <Route
                                                path={prop.path}
                                                key={key}
                                                render={routeProps =>
                                                    <prop.component
                                                        {...routeProps}
                                                        login={this.login}
                                                        user={this.state.user}
                                                    />}
                                            />
                                        );
                                }

                                if (prop.name === "Dashboard")
                                    return (
                                        <Route
                                            path={prop.path}
                                            key={key}
                                            render={routeProps =>
                                                <prop.component
                                                    {...routeProps}
                                                    school={this.state.school}
                                                    submissions={this.state.submissions}
                                                    schoolKey={this.state.schoolKey}
                                                    revenue={this.state.revenue}
                                                    numPaidSubmissions={this.state.numPaidSubmissions}
                                                    histogram={this.state.histogram}
                                                    dateChart={this.state.dateChart}
                                                    lateFees={this.state.lateFees}
                                                />}
                                        />
                                    );
                                if (prop.name === "Submissions")
                                    return (
                                        <Route
                                            path={prop.path}
                                            key={key}
                                            render={routeProps =>
                                                <prop.component
                                                    {...routeProps}
                                                    school={this.state.school}
                                                    submissions={this.state.submissions}
                                                    schoolKey={this.state.schoolKey}
                                                />}
                                        />
                                    );
                                return (
                                    <Route path={prop.path} component={prop.component} key={key}/>
                                );
                            })
                        }
                    </Switch>
                    <Footer/>
                </div>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App/App.jsx